import type { QuestionComponentProps } from "../../types";
import { RadioButtonsQuestion as DefaultRadioButtonsQuestion } from "./RadioButtonsQuestion";
import { RadioButtonsQuestion as ExperimentRadioButtonsQuestion } from "./ExperimentWayhtdtOverlays/RadioButtonsQuestion";
import { useExperiment } from "../../../../../../../hooks/experiments";

export * from "./iconMap";

const WAYHTDT_BUSINESS_Q2Q_NO_HYDRA_EXPERIMENT_KEY =
  "uk2602WayhtdtQuestionBusinessQ2qNoHydra";
const WAYHTDT_BUSINESS_Q2Q_NO_HYDRA_QUESTION_NAME =
  "What are you here to do v2";

export const RadioButtonsQuestion = (props: QuestionComponentProps) => {
  const experimentVariant = useExperiment(
    WAYHTDT_BUSINESS_Q2Q_NO_HYDRA_EXPERIMENT_KEY,
  );

  if (
    experimentVariant === "popups" &&
    props.questionFieldProps.name ===
      WAYHTDT_BUSINESS_Q2Q_NO_HYDRA_QUESTION_NAME
  ) {
    return <ExperimentRadioButtonsQuestion {...props} />;
  }

  return <DefaultRadioButtonsQuestion {...props} />;
};
